import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--blog-publication"
export default class extends Controller {
  static targets = [ "publishCheckbox", "publishAtField", "hint" ]

  connect() {
    this.sync()
  }

  toggle() {
    this.sync()
  }

  sync() {
    const publishing = this.publishCheckboxTarget.checked

    this.publishAtFieldTarget.disabled = !publishing

    if (!publishing) {
      this.publishAtFieldTarget.value = ""
      this.hintTarget.textContent = "Draft mode: publish date is cleared until publish is enabled."
      return
    }

    this.hintTarget.textContent = "Choose a future date to schedule. If left blank, saving publishes immediately."
  }
}
